import { ButtonAction } from 'icreate/common/models/editor-viewer-element';

export class ActionList {
    translateString: string;
    action: ButtonAction;
}

export const actionList: ActionList[] = [
    {
        translateString: 'mimic.settings.buttons.action.setChannel',
        action: ButtonAction.SET_CHANNEL,
    },
    { translateString: 'mimic.settings.buttons.action.turnOn', action: ButtonAction.TURN_ON },
    { translateString: 'mimic.settings.buttons.action.turnOff', action: ButtonAction.TURN_OFF },
    {
        translateString: 'mimic.settings.buttons.action.changeToRun',
        action: ButtonAction.CHANGE_TO_RUN,
    },
    {
        translateString: 'mimic.settings.buttons.action.changeToStop',
        action: ButtonAction.CHANGE_TO_STOP,
    },
    {
        translateString: 'mimic.settings.buttons.action.displayChannel',
        action: ButtonAction.DISPLAY_CHANNEL,
    },
];
